import styled, { css } from 'styled-components';
import { media } from '@trs/utils';

const getPositionStyle = ({ position, theme }) => {
  const { palette, spacing } = theme;

  switch (position) {
    case 'bottom':
    default:
      return {
        tooltipPosProps: `top: ${spacing.basePlus}; left: calc(100% - 280px);`,
        tooltipBeforeProps: `
          top: -${spacing.tiny};
          right: ${spacing.basePlus};
          border-bottom-color: ${palette.utility.border};
          border-bottom-width: ${spacing.tiny};
          border-bottom-style: solid;
        `,
        tooltipAfterProps: `
          top: calc(-${spacing.tiny} + 2px);
          right: ${spacing.basePlus};
          border-bottom-color: ${palette.basic.white};
          border-bottom-width: ${spacing.tiny};
          border-bottom-style: solid;
        `,
      };
  }
};

const StyledReadMoreButton = styled.div`
  ${({ theme, isOpen, position }) => {
    const {
      palette,
      typography,
      spacing,
      extra: { boxShadow, genericBorderRadius },
    } = theme;

    const { tooltipPosProps, tooltipBeforeProps, tooltipAfterProps } = getPositionStyle({
      position,
      theme,
    });

    return css`
      display: inline-block;

      * {
        -moz-user-select: none;
      }

      .tooltip-text {
        display: block;
        position: absolute;
        ${tooltipPosProps}
        z-index: 3;
        width: 300px;
        color: ${palette.gray.bravo};
        font-size: ${typography.size.table};
        line-height: ${typography.lineHeight.paragraphSmall};
        background-color: ${palette.basic.white};
        border: 1px solid ${palette.utility.border};
        box-shadow: ${boxShadow};
        border-radius: ${genericBorderRadius};

        .wrapper-class {
          max-width: 550px;
          max-height: 160px;
          overflow-y: auto;
          padding: ${spacing.tiny};
          box-sizing: border-box;
        }

        &:before {
          content: '';
          position: absolute;
          ${tooltipBeforeProps}
          border-left: ${spacing.tiny} solid transparent;
          border-right: ${spacing.tiny} solid transparent;
        }

        &:after {
          content: '';
          position: absolute;
          ${tooltipAfterProps}
          border-left: ${spacing.tiny} solid transparent;
          border-right: ${spacing.tiny} solid transparent;
        }

        .public-DraftEditor-content {
          > div {
            > div:first-child > div {
              margin-top: 0;
            }

            > div:last-child > div {
              margin-bottom: 0;
            }
          }
        }
      }

    ${media.mobile`
      .tooltip-text {
        width: 190px;
        left: calc(100% - 165px); 
      }
    `}

    ${media.tabletLandscape`

      .tooltip-text {
        width: 300px;
        left: calc(100% - 280px);
      }
    `}

      .read-more {
        color: #007DBB;
        border: none;
        background-color: transparent;
        cursor: pointer;
        margin-left: ${spacing.tiny};
        font-size: ${typography.size.table};
        font-weight: ${typography.weight.normal};
        font-family: inherit;
        word-break: initial;
      }

      a {
        color: ${palette.secondary};
      }

      i {
        border: 1px solid ${palette.basic.gray};
        border-radius: 50%;
        padding: 2px 6px;
        cursor: pointer;

        ${isOpen &&
          css`
            background-color: ${palette.secondary};
            border-color: ${palette.secondary};
            color: ${palette.basic.white};
          `}
      }
    `;
  }}
`;

StyledReadMoreButton.displayName = 'StyledReadMoreButton';
export default StyledReadMoreButton;
